import { ROUTES_CREATE_CLUB } from '@/constants/routes';

export default {
    path: '/create-club',
    name: ROUTES_CREATE_CLUB,
    component: () => import(/*webpackChunkName: 'create-club'*/ '@/views/CreateClub.vue')
};
